// React
import type { RouteRecord } from 'vite-react-ssg';

// Views
import Page, { pageLoader } from '@/views/Page/Page';

// Types
import { type PageSlugType } from '@/services/pages/pagesService';

export const buildNestedRoutes = (pages: PageSlugType[]): RouteRecord[] => {
  const routes: RouteRecord[] = [];
  
  pages.forEach(({ slug, seo }) => {
    slug.split('/').filter(Boolean).reduce((currentLevel, segment, index, segments) => {
      const isLastSegment = index === segments.length - 1;
      
      let route = currentLevel.find(r => r.path === segment);
      
      if (!route) {
        route = { path: segment, children: [] };
        currentLevel.push(route);
      }
      
      if (isLastSegment) {
        Object.assign(route, {
          Component: () => <Page key={slug} />,
          loader: pageLoader,
          handle: { breadcrumb: seo.breadcrumbTitle || seo.metaTitle }
        });
      }
      
      return route.children || [];
    }, routes);
  });
  
  return routes;
};